import { LocationCodeAutocompleteViewStore } from '@planning/stores/locationCode/LocationCodeAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'

export type LocationCodeAutoCompleteProps<M extends boolean = false> = {
  onChange: (locationCodes: M extends true ? string[] : string) => void
} & TomAutoCompleteProps<string, M>

export const LocationCodeAutoComplete = observer(
  <M extends boolean = false>(props: LocationCodeAutoCompleteProps<M>) => {
    const { t } = useTranslate()
    const { dataCy, defaultValue, label, onChange } = props

    const store = useMemo(() => new LocationCodeAutocompleteViewStore(), [])

    return (
      <TomAutoComplete
        {...props}
        enablePortal
        dataCy={dataCy ?? 'location-code-autocomplete'}
        label={label ?? t('locationCode', 'Location Code')}
        options={store.options}
        defaultValue={defaultValue}
        placeholder={t('startTypingTOGetlocationCode', 'Start typing to get location code')}
        onChangeEntity={entity => {
          onChange(entity as M extends true ? string[] : string)
        }}
        onChangeFilter={filter => store.filterOptions(filter?.toUpperCase())}
      />
    )
  },
)
